<template>
    <div class="child-layout">
        <header>
            <div class="container">
                <img src="@/assets/img/upmood_icon.png" alt="Upmood" class="logo">
                <img class="arrow" src="@/assets/img/arrow-left.svg" alt="<<<" @click="goToHome()">
                <h3>
                    <a @click.prevent="goToHome()" :class="{ 'loading' : loading }">
                        {{ routerInfo.name }}
                    </a>

                    <loading v-if="loading" class="loading-container"/>
                </h3>

                <section @click="toggleOptions = !toggleOptions">
                    {{ user.first_name + ' ' + user.last_name }}
                    <img src="@/assets/img/avatar-default.png" alt="" class="avatar">

                    <div class="options" v-if="toggleOptions">
                        <button @click="$store.dispatch('auth/signOut')">{{ $t('logout') }}</button>
                    </div>
                </section>
            </div>
        </header>

        <main>
            <div class="container">
                <slot />
            </div>
        </main>
        <AppFooter/>
    </div>
</template>
<script>
import * as router from '@/store/router/app.js'
import { mapFields } from 'vuex-map-fields'
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},

        routerId: {
            type: String
        }
	},

    beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', router.default)
		}
	},

    created () {
        this.$store.dispatch('router/getRouterInfo', this.routerId)
    },

	data () {
		return {
			toggleOptions: false
		}
	},

	computed: {
		...mapFields('auth', ['user']),
		...mapFields('router', ['routerInfo'])
	},

	methods: {
		goToHome () {
			if (this.loading) return
			this.$router.go(-1)
			// this.$router.push({ name: this.$route.meta.home })
		}
	}
}
</script>>

<style lang="scss" scoped>
.child-layout {
    background-color: #F5F6FA;
    height: 100%;
    display: flex;
    flex-direction: column;

    header {
        background-color: #fff;
        box-shadow: 0 2px 6px #0000000A;
        padding: .5rem 1.5rem;

        .container {
            display: flex;
            align-items: center;

            section {
                margin-left: auto;
                cursor: pointer;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                position: relative;

                .avatar {
                    margin-left: 1rem;
                    border-radius: 50%;
                    width: 3rem;
                }
            }

            .options {
                position: absolute;
                top: 2rem;
                left: 1rem;
                margin-top: 1rem;
                background-color: #fff;
                box-shadow: 0 0.15rem 0.3rem #aaa;

                button {
                    color: #d18383;
                    padding: 0.5rem 2rem;
                }
            }
        }

        .logo {
            width: 4rem;
        }

        img {
            margin-right: 2rem;

            &.arrow {
                cursor: pointer;
            }
        }

        h3 {
            display: flex;
            align-items: center;

            a {
                display: flex;
                align-items: center;
                margin-right: .5rem;
                text-transform: capitalize;

                &.loading {
                    opacity: 0.7;
                    pointer-events: none;
                }
            }

            .loading-container {
                height: 15px;
                width: 15px;

                ::v-deep div {
                    width: 5px;

                    &:nth-child(1) {
                        left: 0;
                    }

                    &:nth-child(2) {
                        left: 7px;
                    }

                    &:nth-child(3) {
                        left: 14px;
                    }
                }
            }
        }
    }

    main {
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        overflow: auto;

        .container {
            padding: 2rem 1.5rem;
            height: 100%;
            width: 100%;
        }
    }

    .app-footer {
        padding: 0.5rem 1.5rem;
        width: 100%;
        font-size: 12px;
        font-weight: 600;
    }
}
</style>
